import React from 'react'

import { useCompareProperty } from '@adUtilities/components/compare-property/utils'
import { ComparableProperty, PropertyType } from '@adUtilities/types'

import ComparableLotItem from './comparable-lot-item'
import LotSelector from './comparable-lot-item/lot-selector'
import ComparableUnitItem from './comparable-unit-item'
import UnitSelector from './comparable-unit-item/unit-selector'

interface ComparablePropertyItemProps {
  comparePropertyProps: ReturnType<typeof useCompareProperty>
  comparableProperty: ComparableProperty
  propertyListType: PropertyType
  onSelectPrecinct?: (id: string) => void
}

function ComparablePropertyItem({
  comparePropertyProps,
  comparableProperty,
  propertyListType,
  onSelectPrecinct,
}: ComparablePropertyItemProps) {
  if (
    comparableProperty.property &&
    comparableProperty.property.propertyType === PropertyType.Unit
  ) {
    return (
      <ComparableUnitItem
        unit={comparableProperty.property}
        comparePropertyProps={comparePropertyProps}
      />
    )
  }

  if (
    comparableProperty.property &&
    comparableProperty.property.propertyType === PropertyType.Lot
  ) {
    return (
      <ComparableLotItem
        lot={comparableProperty.property}
        comparePropertyProps={comparePropertyProps}
        onSelectPrecinct={onSelectPrecinct}
      />
    )
  }

  if (!comparableProperty.property && propertyListType === PropertyType.Unit) {
    return (
      <div className="flex h-full w-full flex-col gap-[15px] pt-[6px]">
        <UnitSelector comparePropertyProps={comparePropertyProps} />
      </div>
    )
  }

  if (!comparableProperty.property && propertyListType === PropertyType.Lot) {
    return (
      <div className="flex h-full w-full flex-col gap-[15px] pt-[6px]">
        <LotSelector comparePropertyProps={comparePropertyProps} />
      </div>
    )
  }

  return null
}

export default ComparablePropertyItem
